import { render } from "./KryptonWalletTabs.vue?vue&type=template&id=0fb46102&lang=pug"
import script from "./KryptonWalletTabs.vue?vue&type=script&lang=js"
export * from "./KryptonWalletTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__